import { Placement, Tooltip } from '@aus-platform/design-system';
import type { DatasetDetailsTooltipProps, TooltipTextProps } from './types';
import { LayerType } from 'shared/api';
import { SceneMode } from 'cesium';
import { useAppSelector } from 'app/hooks';
import { selectMap3DState } from 'map-3d/shared/map-3d-slices';

const TooltipText: React.FC<TooltipTextProps> = ({
  layerName,
  siteName,
  iterationName,
  activeCleanupName,
}) => {
  return (
    <div className="dataset-details-tooltip">
      {layerName && (
        <div className="dataset-details-tooltip__grid-container">
          <div>Layer </div>
          <strong>{layerName}</strong>
        </div>
      )}
      {siteName && (
        <div className="dataset-details-tooltip__grid-container">
          <div>Site </div>
          <strong>{siteName}</strong>
        </div>
      )}
      {iterationName && (
        <div className="dataset-details-tooltip__grid-container">
          <div>Iteration </div>
          <strong>{iterationName}</strong>
        </div>
      )}
      {activeCleanupName && (
        <div className="dataset-details-tooltip__grid-container">
          <div>Cleanup </div>
          <strong>{activeCleanupName}</strong>
        </div>
      )}
    </div>
  );
};

export const DatasetDetailsTooltip: React.FC<DatasetDetailsTooltipProps> = ({
  siteName,
  layerName,
  iterationName,
  activeCleanupName,
  layerType,
  children,
  placement = Placement.Right,
  show,
}) => {
  const { currentSceneMode } = useAppSelector(selectMap3DState);
  const isPointCloudIn2D =
    layerType === LayerType.PointCloud &&
    currentSceneMode === SceneMode.SCENE2D;

  const hoverText = isPointCloudIn2D ? (
    'Point cloud layers are not supported in 2D view.'
  ) : (
    <TooltipText
      siteName={siteName}
      layerName={layerName}
      iterationName={iterationName}
      activeCleanupName={activeCleanupName}
    />
  );

  return (
    <Tooltip
      hoverText={hoverText}
      placement={placement}
      className="dataset-details-tooltip-container"
      show={show}
    >
      {children}
    </Tooltip>
  );
};
